interface ReleaseQueueHistory {
  key: string;
  fromKey?: string;
}

function currentState(): Record<string, unknown> {
  return window.history.state && typeof window.history.state === "object"
    ? window.history.state as Record<string, unknown>
    : {};
}

// History stores only identities; queue data and positions stay in page memory.
export function releaseQueueHistory(): ReleaseQueueHistory {
  const state = currentState();
  const saved = state.releaseQueue as Partial<ReleaseQueueHistory> | undefined;
  if (saved && typeof saved.key === "string") {
    return typeof saved.fromKey === "string"
      ? { key: saved.key, fromKey: saved.fromKey }
      : { key: saved.key };
  }
  const entry = { key: crypto.randomUUID() };
  window.history.replaceState({ ...state, releaseQueue: entry }, "");
  return entry;
}

export function releaseNavigationHistoryState(detail: boolean): Record<string, unknown> {
  const origin = releaseQueueHistory();
  return {
    ...currentState(),
    releaseQueue: detail ? origin : { key: crypto.randomUUID(), fromKey: origin.key }
  };
}
